module.exports = __webpack_public_path__ + "49db2913f8e1e5975de70feb43054503.svg";